import {
  Box,
  ListItemAvatar,
  ListItemText,
  MenuItem,
  styled,
  Typography,
} from "@mui/material";
import React from "react";
import { Avatar } from "../../components";
import { User } from "../../modules/authentication/domain";

const StyledMenuItem = styled(MenuItem)({
  minHeight: "auto !important",
  '&.MuiAutocomplete-option[aria-disabled="true"]': {
    opacity: 1,

    ".MuiListItemAvatar-root, .MuiListItemText-primary": {
      opacity: 0.45,
    },
  },
  borderRadius: "0",
  marginTop: "8px",
});

const StyledListItemAvatar = styled(ListItemAvatar)(({ theme }) => ({
  alignSelf: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  width: "24px",
  height: "24px",
  backgroundColor: theme.palette.shades.greyExtraLight,
  marginRight: "8px",
  color: theme.palette.shades.greyMedium,
}));

const StyledAvatar = styled(Avatar)({
  width: 32,
  height: 32,
});

export const MemberMenuItemContent: React.FC<{
  elementProps: React.HTMLAttributes<HTMLLIElement>;
  name: string;
  icon?: React.ReactNode;
  available?: boolean;
  avatarImageUrl?: string;
  team?: string | null;
  errorText?: string;
  user?: User;
  isTeamOption?: boolean;
  isSelected?: boolean;
}> = React.memo(
  ({
    elementProps,
    name,
    icon,
    available,
    avatarImageUrl,
    team,
    errorText,
    user,
    isTeamOption = false,
    isSelected = false,
  }) => {
    return (
      <StyledMenuItem {...elementProps}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {icon && (
            <StyledListItemAvatar sx={{ minWidth: 24 }}>
              {icon}
            </StyledListItemAvatar>
          )}
          {!icon && (
            <StyledListItemAvatar sx={{ minWidth: 32 }}>
              <StyledAvatar
                src={avatarImageUrl}
                user={user!}
                size={32}
                isGroup={isTeamOption}
              />
            </StyledListItemAvatar>
          )}
          <ListItemText
            primary={
              <Typography
                variant="body2"
                fontWeight={isTeamOption ? 500 : 400}
                sx={{ whiteSpace: "normal", wordBreak: "break-word" }}
              >
                {name}
              </Typography>
            }
            secondary={
              available === false && errorText ? (
                <Typography variant="body3" color="errors.regular">
                  {errorText}
                </Typography>
              ) : (
                !isTeamOption &&
                team !== null &&
                team !== undefined && (
                  <Typography
                    variant="body3"
                    color="shades.grey"
                    noWrap
                    sx={{
                      maxWidth: 260,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {team}
                  </Typography>
                )
              )
            }
          />
        </Box>
      </StyledMenuItem>
    );
  }
);
